export const iconFontAwesomeUsersPeoplePersonMilitaryPointing = (
	<i className="fa-solid fa-person-military-pointing"></i>
);
